import { TextField, Button } from "@mui/material";
import React, { useState, useEffect } from "react";
import { getListIssues, getGridData } from "../api/api";
import Tabela from "./Tabela";
import Box from "@mui/material/Box";
import Loading from "./Loading";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";

function Form() {
  //const [inicio, setInicio] = useState();
  const [startDate, setStartDate] = useState();
  const [fim, setFim] = useState();
  const [submit, setSubmit] = useState(false);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [maxProgress, setMaxProgress] = useState(0);
  //const [startDate, setStartDate] = useState(new Date());

  function Progressbar(props) {
    const normalize = (value) => ((value) * 100 / (maxProgress));
      return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ width: '100%', mr: 1 }}>
            <LinearProgress variant="determinate" value={normalize(props.value)} />
          </Box>
          <Box sx={{ minWidth: 35 }}>
            <Typography variant="body2" color="text.secondary">{Math.round(normalize(props.value))+'%'}</Typography>
          </Box>
        </Box>
      );
  }

  useEffect(() => {
    if(progress === maxProgress) {
      setLoading(false);
      console.log("effect : " + progress);
      setProgress(0);
      setMaxProgress(100);
    }
  }, [fim, list, progress, maxProgress]);

  function onDatehandler(date){
    setStartDate(date);
    setFim(date.toISOString().split('T')[0]);
  }


  function onSubmitHandler() {
    setLoading(true);
    setList([]);
    var temp = [];
    var i = 1;
    console.log(startDate.toISOString().split('T')[0]);
    
    getListIssues(fim)
      .then((result) => {
        setMaxProgress(result.data.length);
        result.data.map((issue) =>
          getGridData("635b1b90e469cf99621ee27e", issue.key)
            .then((res) => {
              if(res.data != null) {
                if(res.data[0].columns.materiais != null) {
                  issue["material"] = res.data;
                  temp.push(issue);
                  setList([...temp]);
                }
              }
              setProgress(i++);
            })
            .catch((e) => {
              setProgress(i++);
              //console.log(e);
            })
        );
      })
      .catch((error) => {
        console.log(error);
      })

      
  }
  

  return (
    <div>
      <br />
      <br />
      <div>
        <label className="">Relatório de <b>Materiais</b> Aplicados</label>
      </div>
      <br />
      <form
        onSubmit={(event) => {
          event.preventDefault();
          onSubmitHandler();
          setSubmit(true);
        }}
      >
        <Box
          component="form"
          sx={{
            "& > :not(style)": { m: 1, width: "25ch" },
          }}
        >
          
          <br />
          

          <DatePicker selected={startDate} onChange={(date) => onDatehandler(date)} />
        </Box>
        <br />
        <br />
        <Button type="submit" variant="contained">
          Consultar
        </Button>
      </form>
      <br />
      {loading && <Progressbar value={progress}/>}
      <br />
      <br />
      {loading && <Loading />}
      <br />
      {submit && <Tabela dados={list} />}
      <br />
    </div>
  );
}

export default Form;
